import React, { useState } from "react";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";

import { NavLink, useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const nav = useNavigate();

  //forgot password

  const [userName, setUserName] = useState("");

  const [showOtpInput, setShowOtpInput] = useState(false);
  const [otp, setOtp] = useState("");
  const [showNewPasswordFields, setShowNewPasswordFields] = useState(false);
  const [userId, setUserId] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prev) => !prev);
  };

  const [isOtpVisible, setIsOtpVisible] = useState(false);
  const toggleOtpVisibility = () => {
    setIsOtpVisible((prev) => !prev);
  };

  const handleUserNameChange = (event) => {
    setUserName(event.target.value);
  };

  const handleSendOTP = (event) => {
    event.preventDefault();

    let url = `${process.env.REACT_APP_BASE_URL}/api/forgotPassword/`;

    fetch(url, {
      method: "POST",

      body: JSON.stringify({
        userName: userName,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((data) => {
        if (data.status == 400) {
          toast.error("Unable to send OTP.");
        } else if (data.status == 200) {
          //console.log(data);
          toast.info(`send otp to ${userName}`);
          setShowOtpInput(true);
          data.json().then((res) => {
            //console.log(res);

            setUserId(res.id);
          });
        } else {
          toast.error("something went wrong");
        }
      })
      .catch((err) => {
        // //console.log(err);
        toast.error(`${err}`);
      });
  };

  const handleReset = (event) => {
    event.preventDefault();

    let url = `${process.env.REACT_APP_BASE_URL}/api/resetPassword/`;

    fetch(url, {
      method: "POST",

      body: JSON.stringify({
        otp: otp,
        password: newPassword,
        id: userId,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((data) => {
        data.json().then((res) => {});
        if (data.status == 404) {
          toast.error("otp not match");
        } else if (data.status == 200) {
         

          setShowNewPasswordFields(false);
          nav("/auth");
          toast.success(`Password Change successfully`);
        } else {
          toast.error("something went wrong");
        }
      })
      .catch((err) => {
        toast.error(`${err}`);
      });
  };
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        bodyClassName="toastBody"
      />
      <div className="hold-transition login-page login-wall">
        <div className="login-box">
          <div className="login-logo">
            <a href="">
              <b>Forgot Password</b>
            </a>
          </div>

          <div className="card">
            <div className="card-body login-card-body">
              <p className="login-box-msg">
                You forgot your password? Here you can easily retrieve a new
                password.
              </p>
              {!showOtpInput && (
                <>
                  <form onSubmit={handleSendOTP}>
                    <div className="input-group mb-3">
                      <input
                        type="text"
                        id="userName"
                        className="form-control"
                        placeholder="User Name"
                        value={userName}
                        onChange={handleUserNameChange}
                        required
                      />
                      <div className="input-group-append">
                        <div className="input-group-text">
                          <span className="fas fa-user" />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <button
                          type="submit"
                          className="btn btn-primary btn-block"
                        >
                          Request new password
                        </button>
                      </div>
                    </div>
                  </form>
                  <p className="mt-3 mb-1">
                    <NavLink to="/auth">Login</NavLink>
                  </p>
                </>
              )}
              {showOtpInput && (
                <>
                  <form onSubmit={handleReset}>
                    <div className="input-group mb-3">
                      <input
                        type={isOtpVisible ? "text" : "password"}
                        id="otp"
                        className="form-control"
                        placeholder="OTP"
                        value={otp}
                        onChange={(event) => setOtp(event.target.value)}
                        required
                      />
                      <div className="input-group-append">
                        <div className="input-group-text">
                          <span
                            className={`fas ${
                              isOtpVisible ? "fa-eye-slash" : "fa-eye"
                            }`}
                            onClick={toggleOtpVisibility}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="input-group mb-3">
                      <input
                        type={isPasswordVisible ? "text" : "password"}
                        id="newPassword"
                        className="form-control"
                        placeholder="New Password"
                        value={newPassword}
                        onChange={(event) => setNewPassword(event.target.value)}
                        required
                      />
                      <div className="input-group-append">
                        <div className="input-group-text">
                          <span
                            className={`fas ${
                              isPasswordVisible ? "fa-eye-slash" : "fa-eye"
                            }`}
                            onClick={togglePasswordVisibility}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-6">
                        <button
                          type="submit"
                          className="btn btn-primary btn-block"
                        >
                          Change password
                        </button>
                      </div>
                      <div className="col-6">
                        <button
                          type="submit"
                          className="btn btn-success btn-block"
                          onClick={() => nav("/auth")}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
